<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h2>Pick File For Upload</h2>
                </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row justify-content-md-center upload">
                <div class="col-xl-5">
                    <div class="card p-3">
                        <div class="card-header bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h5 class="mb-3">Pick File For Upload</h5>
                                </div>
                            </div>
                        </div>
                        <span class="round"><img src="@/assets/img/vector/download.png" alt /></span>

                        <form class="mt-4">
                            <div class="form-row settings">
                                <!-- <div class="form-group col-md-6">
                                    <label for="inputEmail4">Settlement From</label>
                                    <datepicker 
                                        v-model="settilementDateFrom" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="inputEmail4">Settlement To </label>
                                    <datepicker 
                                        v-model="settilementDateTo" 
                                        placeholder="mm/dd/yyyy" 
                                        typeable 
                                        name="callDate" 
                                        format="MM/dd/yyyy" 
                                        :calendar-button="true" 
                                        calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                                    
                                </div> -->
                                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                                <div class="form-group col-md-12 text-center">
                                    <!-- <button type="button" class="btn btn-light">RESET</button> -->
                                    <button @click="exportData()" type="button" class="btn btn-success">EXPORT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import authService from "@/authService";
import config from "@/config";
// import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsComponent",
  components : {
    //   Datepicker
  },
  data() {
    return {
        settilementDateFrom :null,
        settilementDateTo :null,
        loading : false,
        disabledDates: {
          to: this.getYestedayDate()
        },

    };
  },
  methods: { 

    exportData(){
        this.loading = true;
        //data.overrideSettlementDate = this.settilementDate ? this.settilementDate : "" ;
        // let fromDate = this.settilementDateFrom ? this.moment(this.settilementDateFrom).format("MM/DD/YYYY")  : "" ;
        // let toDate = this.settilementDateTo ? this.moment(this.settilementDateTo).format("MM/DD/YYYY")  : "" ;
         const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/excel/report-inventory-offers",
            auth
        )
        .then((response) => {
            this.loading = false;
            if(response.data){
                window.open(response.data, "_blank");
            }
        }).catch(() => this.loading = false)     

    }
  },
  mounted() {

    this.settilementDateFrom = this.moment().format("MM-DD-YYYY");
    this.settilementDateTo = this.moment().format("MM-DD-YYYY");

    
  }
};
</script>